<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
height: 100%; background: lightgrey">
      <!--v-dialog
          :value="showDialog"
          max-width="450px"
      -->
        <v-card class="align-center justify-center" style="width: 450px; position: relative; left: calc(50% - 225px); top: calc(50% - 200px)">
          <v-card-title>
            <span class="text-h5">Datenauswahl treffen</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                >
                  <v-dialog
                      ref="dialog_select_start"
                      v-model="selectModalStart"
                      :return-value.sync="selectDateStart"
                      width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="formatedDateStart"
                          label="Auswertungsstart"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="selectDateStart"
                        :picker-date.sync="selectDateStart"
                        type="date"
                        scrollable
                        locale="de"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          color="primary"
                          @click="selectModalStart = false"
                      >
                        Abbrechen
                      </v-btn>
                      <v-btn
                          text
                          color="primary"
                          @click="setDateStart(selectDateStart)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-dialog
                      ref="dialog_select_end"
                      v-model="selectModalEnd"
                      :return-value.sync="selectModalEnd"
                      persistent
                      width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="formatedDateEnd"
                          label="Auswertungsende"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="selectDateEnd"
                        :picker-date.sync="selectDateEnd"
                        type="date"
                        scrollable
                        locale="de"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          color="primary"
                          @click="selectModalEnd = false"
                      >
                        Abbrechen
                      </v-btn>
                      <v-btn
                          text
                          color="primary"
                          @click="setDateEnd(selectDateEnd)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-select
                      v-if="reportType === 'ML'"
                      v-model="selectedMita"
                      :items="mitasFlat"
                      item-text="name"
                      item-value="id"
                      label="Mitarbeiter wählen"
                      return-object
                      single-line
                  ></v-select>
                </v-col>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                :disabled="reportType === 'ML' && !selectedMita"
                @click="showAuswertung"
            >
              Auswertung ausgeben
            </v-btn>
          </v-card-actions>
        </v-card>
      <!--/v-dialog-->
    </div>
    <report-overlay ref="reportOverlay" :hide-loader="hideLoader" :show-loader="showLoader" @close="showDialog = true"></report-overlay>

  </v-main>
</template>

<script>
import {Cookie_Path, Redirect_Login, Server_URL} from "@/shared/utils";
import ReportOverlay from "@/views/calculation/report_overlay.vue";
import _orderBy from "lodash/orderBy"

import {decryptPositions} from "@/shared/crypto";

export default {
  name: "report",
  components:
      {
        ReportOverlay
      },
  computed: {
    formatedDateStart() {
      if (this.selectDateStart) {
        return this.selectDateStart.split("-").reverse().join(".");
      } else {
        return ""
      }
    },
    formatedDateEnd() {
      if (this.selectDateEnd) {
        return this.selectDateEnd.split("-").reverse().join(".");
      } else {
        return ""
      }
    },
  },
  created: function () {
    this.reportSubType = window.location.href.split('/').slice(-1)[0];
    this.reportType = this.reportSubType.substring(0, 2)
    console.log(this.reportType, this.reportSubType)
    switch (this.reportSubType) {
      case "PSA":
        this.request.data.aggregationType =  0;
        this.request.name = "Produkt-Sachkonto, Summen Arbeitsstunden";
        break;
      case "PSF":
        this.request.data.aggregationType =  0;
        this.request.name = "Produkt-Sachkonto, Summe Fahrzeugstunden";
        break;
      case "PSAF":
        this.request.data.aggregationType =  0;
        this.request.name = "Produkt-Sachkonto, Arbeits- u. Fahrzeugleistungen";
        break;
      case "LLA":
        this.request.data.aggregationType =  0;
        this.request.name = "Leistungen je Auftragsgruppe";
        break;
      case "LLL":
        this.request.data.aggregationType =  1;
        this.request.name = "Leistungen je Leistungsgruppe";
        break;
      case "FFL":
        this.request.data.aggregationType =  0;
        this.request.name = "Fahrzeugleistungen je Leistungsgruppe";
        break;
      case "FFP":
        this.request.data.aggregationType =  1;
        this.request.name = "Fahrzeugleistungen je Produkt-Sachkonto";
        break;
      case "MLA":
        this.request.data.aggregationType =  0;
        this.request.name = "Mitarbeiterleistungen je Auftragsgruppe";
        break;
      case "MLL":
        this.request.data.aggregationType =  0;
        this.request.name = "Mitarbeiterleistungen je Leistungsgruppe";
        break;
      case "MLS":
        this.request.data.aggregationType =  0;
        this.request.name = "Mitarbeiterleistungen je Stammauftrag";
        break;
      case "AJD":
        this.request.data.aggregationType =  0;
        this.request.name = "Auftragsjournal, Details je Auftrag";
        break;
      case "AJS":
        this.request.data.aggregationType =  0;
        this.request.name = "Auftragsjournal, Summen je Auftrag";
        break;
      case "AJU":
        this.request.data.aggregationType =  0;
        this.request.name = "Auftragsjournal, mit Unteraufträgen";
        break;
    }
    if (this.reportType === "ML") {
      this.showLoader();
      this.$http.get(
          Server_URL+'/auftragsbuch/report',
      ).then(this.responseOkGet, this.responseError)
    }
  },
  data: () => ({
    mitasFlat: [],
    selectedMita: null,
    startDate: null,
    endDate: null,
    showDialog: true,
    selectDateStart: null,
    selectModalStart: false,
    selectDateEnd: null,
    selectModalEnd: false,
    reportType: '',
    reportSubType: '',
    bhStructure: null,
    request: {
      customerNumber: '',
      aesKey: '',
      finished: false,
      filename: '',
      name: 'Test',
      data: {
        auswahl: '',
        commune: '',
        employeeName: '',
        employeeNumber: '',
        date: null,
        periodStart: null,
        periodEnd: null,
        aggregationType: 0,
        metric: 0,
      }
    }
  }),
  methods: {
    responseError(response) {
      this.hideLoader();
      console.log(response);
      if (response.status === 401) {
        //window.location = Redirect_Login;
      } else {
        //window.location = Redirect_500;
      }
    },
    async responseOkGet(response) {
      this.hideLoader();
      console.log(response);
      if (response.status === 200 ) {
        for (let i = 0; i < response.body.length; i++) {
          let mita = response.body[i];
          mita.name = this.getMitaNameForGischl(mita);
          this.mitasFlat.push(mita)
        }
        this.mitasFlat = _orderBy(this.mitasFlat, 'name');
        console.log(this.mitasFlat)
      } else {
        //window.location = Redirect_500;
        console.log(response);
      }
    },
    setDateStart(date) {
      this.$refs.dialog_select_start.save(date);
      this.selectModalStart = false;
      },
    setDateEnd(date) {
      this.$refs.dialog_select_end.save(date);
      this.selectModalEnd = false;
    },
    showLoader() {
      if (this.loader === undefined)
        this.loader = this.$loading.show();

    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    showAuswertung() {
      let auswahl = "";
      let start = null;
      if (this.selectDateStart) {
        start = new Date(this.selectDateStart);
        auswahl = this.selectDateStart.split("-").reverse().join(".") + " - ";
      } else {
        auswahl = "Alle Daten - "
      }
      this.request.data.periodStart = start;
      let end = null;
      if (this.selectDateEnd) {
        end = new Date(this.selectDateEnd);
        auswahl += this.selectDateEnd.split("-").reverse().join(".");
      } else {
        auswahl += "Alle Daten"
      }

      this.request.data.auswahl = auswahl;
      this.request.data.periodStart = start;
      this.request.data.periodEnd = end;
      if (this.reportType === 'ML') {
        this.request.data.employeeName = this.selectedMita.name;
        this.request.data.employeeNumber = this.selectedMita.pers_number;
      }
      this.request.customerNumber = this.$cookies.get("ps_customer_number");
      this.request.aesKey = sessionStorage.getItem("aes");
      this.showDialog = false;
      this.$refs.reportOverlay.showDialog(this.request, this.reportType, this.reportSubType);
    },
    getMitaNameForGischl(mita) {
      if (mita === null) {
        return null;
      }
      let searchString = mita.bis_id
      if (!mita.bis_id.includes("-")) {
        searchString += "-"
      }
      let res = JSON.parse(sessionStorage.getItem(searchString));
      if (res === null) {
        return value;
      }
      return res.first_name + " " + res.surname;
    },
  }

}
</script>

<style scoped>
  ::v-deep .v-overlay {
    z-index: 198 !important;
  }
</style>
